import usePageVisibilityChange from '@src/hooks/usePageVisibilityChange';
import { useVideoCreatorStore } from '@src/stores-v2';
import { observer } from 'mobx-react-lite';
import NewVideoVersionListener from './NewVideoVersionListener';

const PageVisibilityChangeListener = observer(() => {
  const videoCreator = useVideoCreatorStore();

  usePageVisibilityChange({
    active: [
      // 1. Check if cloudfront links became stale
      videoCreator.refreshManager.handleStoryPopulatedFields,
    ],
  });

  // 2. Check if there's a newer version of the current video
  return <NewVideoVersionListener />;
});

export default PageVisibilityChangeListener;
